import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-demonstrate-future-ru",
  "use": "spr-demonstrate-future-ru-usage",
  "viewBox": "0 0 488 87",
  "content": "<symbol viewBox=\"0 0 488 87\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"spr-demonstrate-future-ru\">\n    <g id=\"spr-demonstrate-future-ru_desctop\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" font-family=\"Roboto-Medium, Roboto\" font-weight=\"400\">\n        <g id=\"spr-demonstrate-future-ru_Group-33\" transform=\"translate(-2.000000, -15.000000)\" fill=\"#FFFFFF\">\n            <text id=\"spr-demonstrate-future-ru_«ЭКСПОЦЕНТР»:\" font-size=\"50\" letter-spacing=\"0.0531914905\">\n                <tspan x=\"0\" y=\"52\">«Экспоцентр»:</tspan>\n            </text>\n            <text id=\"spr-demonstrate-future-ru_выставки-вашего-успе\" font-size=\"35\" letter-spacing=\"0.0372340418\">\n                <tspan x=\"79\" y=\"94\">выставки вашего успеха</tspan>\n            </text>\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ../img/sprite/demonstrate-future-ru.svg
// module id = 150
// module chunks = 0